export default {
    root: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 11,
        },
    },
};
